import { render, staticRenderFns } from "./MainCategory.vue?vue&type=template&id=1db60828&"
import script from "./MainCategory.vue?vue&type=script&lang=js&"
export * from "./MainCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports